<template>
  <div>
    <b-table
      responsive
      hover
      :current-page="currentPage"
      :items="resultData.content"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      :filter="filter"
      @filtered="onFiltered"
    >

    <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
    </template>
      
    <template v-slot:cell(actions)="{ item }">
        <span
          ><b-button
            variant="outline-primary"
            size="sm"
            class="mr-1"
            @click="detailItem(item)"
            >View</b-button
          ></span
        >
        <span
          ><b-button
            variant="outline-primary"
            size="sm"
            class="mr-1"
            @click="editItem(item)"
            >Update</b-button
          ></span
        >
        <span
          ><b-button
            variant="outline-danger"
            size="sm"
            @click="deleteItem(item.provinceId)"
            >Delete</b-button
          ></span
        >
      </template>
    </b-table>

    <!-- pagination -->
    <div>
      <b-pagination
        v-model="currentPage"
        :total-rows="resultData.totalElements"
        :per-page="perPage"
        first-number
        last-number
        @change="handlePageChange"
      >
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import {
  BSpinner,
  BDropdown,
  BDropdownItem,
  BTable,
  BButton,
  BPagination,
} from "bootstrap-vue";

export default {
  components: {
    BSpinner,
    BDropdown,
    BDropdownItem,
    BTable,
    BButton,
    BPagination,
  },
  /* eslint-disable vue/require-default-prop */
  props: {
    result: {
      type: Object,
    },
    isLoading: {
      type: Boolean,
    },
    getData: {
      type: Function,
    },
    detailItem: {
      type: Function,
    },
    editItem: {
      type: Function,
    },
    deleteItem: {
      type: Function,
    },
    handlePageChange: {
      type: Function,
    },
  },
  watch: {
    isLoading(value) {
      this.isLoadingComponent = value;
    },
    result(value) {
      this.resultData = value;
    },
  },
  data() {
    return {
      isLoadingComponent: true,
      resultData: {},
      perPage: 10,
      // totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: {
        title: "",
      },
      fields: [
         
        {
          key: "provinceName",
          label: "Nama",
        },
        {
          key: "provinceCode",
          label: "Kode Provinsi",
        },
        {
          key: "actions",
          label: "Aksi",
        },
      ],
    };
  },
  methods: {
    onFiltered(filteredItems) {
      console.log(filteredItems)
      // this.totalRows = filteredItems.length;
      // this.currentPage = 1;   
      this.totalRows = filteredItems.length
      // this.currentPage = 1
      // this.items.count = filteredItems.length
   
    },
  },
};
</script>
